<template>
  <form @submit.prevent="addCustomStep">
    <HorizontalStepBullets :currentStep="this.currentStep" class="steps-bullets" :totalSteps="this.totalSteps" :stepTitles="['General', 'Values', 'QR']"/>
    <div class="multiple-div" name="step1" v-if="this.currentStep == 1">
      <InputDash
        label="REF"
        name="ref"
        :isTextArea="false"
        value="Auto"
        :isDisabled="true"
      />
      <InputDash
        label="Name"
        name="name"
        :isTextArea="false"
        :isDisabled="false"
        placeholder="Step name"
        v-model="name"
        :validation="!this.inValidFields.includes('name')"
      />
      <InputDash
        label="Equipment"
        name="equipment"
        :isTextArea="false"
        :isDisabled="false"
        placeholder="Used equipment"
        v-model="equipment"
        :validation="!this.inValidFields.includes('equipment')"
      />
      <InputDash
        label="Work Instruction"
        name="instruction"
        :isTextArea="false"
        :isDisabled="false"
        placeholder="Work Instruction"
        v-model="instruction"
        :validation="!this.inValidFields.includes('instruction')"
      />
      <InputDash
        label="Location"
        name="location"
        :isTextArea="false"
        :isDisabled="false"
        placeholder="Surgi-Tec"
        v-model="location"
      />
    </div>

    <div class="multiple-div" name="step2" v-if="this.currentStep == 2">
      <h4>DEFAULT VALUES</h4>
      <div class="shared shared-2">
        <div>
          <label for="operator">Operator</label>
          <InputDash :isTextArea="false" value="Auto" :isDisabled="true" />
        </div>
        <div>
          <label for="date">Date</label>
          <InputDash :isTextArea="false" value="Auto" :isDisabled="true" />
        </div>
      </div>

      <div class="shared shared-2">
        <div>
          <label for="deviations">Deviations</label>
          <InputToggle
            @toggle="toggleDev"
            :isChecked="this.deviations"
            :isDisabled="false"
          />
        </div>
        <div>
          <label for="samplecount">Sample count</label>
          <InputToggle
            @toggle="toggleSample"
            :isChecked="this.samplecount"
            :isDisabled="false"
          />
        </div>
      </div>
      <h4>CUSTOM VALUES</h4>
      <DynamicStepsList
        label="Custom Values"
        name="Custom Values"
        :filledValues="values"
        @updateValues="gotValues"
        :optionDefault="true"
      />
    </div>

    <div class="multiple-div" name="step3" v-if="this.currentStep == 3">
      <div class="shared shared-vertical">
        <h4>QR PARAMETERS</h4>
        <InputToggle @toggle="toggleQR" :isChecked="this.qr" :isDisabled="false" />
      </div>
      <InputDash
        v-if="this.qr"
        label=""
        name="qrparameter"
        :isTextArea="false"
        :isDisabled="false"
        placeholder="QR Parameter name"
        v-model="qrparameter"
        :validation="!this.inValidFields.includes('qrparameter')"
      />
      <h4 v-if="this.qr">QR VALUES</h4>
      <DynamicSimplifiedStepsList
        v-if="this.qr"
        label="QR Values"
        name="QR Values"
        :filledValues="qrparameters"
        @updateValues="gotQRParameters"
      />
    </div>

    <div class="buttons">
      <BaseButton type="button" v-if="this.currentStep == 1" :key="1" color="tertiary" size="modal-sm" @click.native="emitClose(true)">
        Cancel
      </BaseButton>
      <BaseButton type="button" v-if="this.currentStep != 1" :key="2" color="tertiary" size="modal-sm" @click.native="prevStepForm">
        Previous
      </BaseButton>
      <BaseButton type="submit" v-if="this.currentStep == this.totalSteps" :key="3" color="primary" size="modal-sm">
        Add
      </BaseButton>
      <BaseButton type="button" v-else color="primary" :key="4" size="modal-sm" @click.native="nextStepForm">
        Continue
      </BaseButton>
    </div>
  </form>
</template>

<script>
import BaseButton from "@/components/base/Button";
import InputDash from "@/components/base/InputDash";
import DynamicStepsList from "@/components/base/DynamicStepsList";
import DynamicSimplifiedStepsList from "@/components/base/DynamicSimplifiedStepsList";
import HorizontalStepBullets from "@/components/base/HorizontalStepBullets";
import InputToggle from "@/components/base/InputToggle";

export default {
  components: {
    InputDash,
    BaseButton,
    DynamicStepsList,
    DynamicSimplifiedStepsList,
    InputToggle,
    HorizontalStepBullets
  },
  props: {
    title: String
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 3,
      values: [],
      qrparameter: "",
      qrparameters: [],
      name: "",
      deviations: false,
      samplecount: false,
      qr: false,
      equipment: "",
      location: "",
      instruction: "",
      inValidFields: []
    }
  },
  methods: {
    addCustomStep: function() {
      var that = this;
      let filteredValues = this.values.filter(function(el) {
        return el.name != "" || el.id != "";
      }); 
      this.$http
        .post(this.$endpoint + "management/productionStep/step", {
          equipment: this.equipment,
          name: this.name,
          location: this.location,
          instruction: this.instruction,
          deviations: this.deviations,
          samplecount: this.samplecount,
          customValues: filteredValues,
          QRParameter: this.qrparameter,
          QRParameters: this.qrparameters
        })
        .then(function(response) {
          that.$swal(
            `${that.name} added!`,
            `Your production step has been successfully added.`,
            "success"
          );
          that.$emit("closeModal", true);
        })
        .catch(function(error) {
          that.$swal(
            "Oops that went wrong?",
            `Please contact the admin with the following info: ${error}`,
            "error"
          );
        });
    },
    emitClose(isClicked) {
      this.$emit("closeModal", isClicked);
    },
    nextStepForm() {
      this.inValidFields = []

      if (this.name == "") {
        this.inValidFields.push("name")
      }

      if (this.equipment == "") {
        this.inValidFields.push("equipment")
      }

      if (this.instruction == "") {
        this.inValidFields.push("instruction")
      }

      if (this.location == "") {
        this.location = "Surgi-Tec"
      }

      if (this.inValidFields.length == 0) {
        this.currentStep += 1
      }
    },
    prevStepForm() {
      this.currentStep -= 1
    },
    gotValues(newValues) {
      this.values = newValues
    },
    gotQRParameters(newValues) {
      this.qrparameters = newValues
    },
    toggleDev() {
      this.deviations = !this.deviations
    },
    toggleSample() {
      this.samplecount = !this.samplecount
    },
    toggleQR() {
      this.qr = !this.qr
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";

.steps-bullets {
  margin-top: 40px;
}
.shared {
  display: flex;
  justify-content: space-between;
  &-vertical {
    align-items: center;
  }
  &-2 {
    & > div {
      width: 50%;
    }
  }
  &-3 {
    & > div {
      width: 33%;
    }
  }
  &-4 {
    & > div {
      width: 25%;
    }
  }
  div + div {
    margin-left: 20px;
  }
}
</style>
